(function() {
  'use strict';
  angular.module('ringbaPortal').filter('hourFormat', hourFormat);

  function hourFormat() {
    return function(input) {
      if (input === 0) {
        return '12 AM';
      } else if (input === 12) {
        return input + ' PM';
      } else if (input > 12) {
        const newHour = input - 12;
        return newHour + ' PM';
      } else {
        return input + ' AM';
      }
    };
  }
})();
